<template>
  <div class="immersive-embed-holder">
    <div
      v-for="(embed, embedIdx) in EmbedFilters"
      :key="embedIdx"
      :style="'margin-left:3px;'"
    >
      <a class="doc-nav-link" :href="'#e-' + embed.Data.Id">
        {{ embed.Data.Title }}
      </a>
      <EmbedImmersiveLink :EmbedFilters="embed.Children"> </EmbedImmersiveLink>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["EmbedFilters"],
  components: {
    EmbedImmersiveLink: () =>
      import(
        "@/views/components/organisms/embeds/embeds-immersive/EmbedImmersiveLink.vue"
      ),
  },
};
</script>
<style scoped>
.immersive-embed-holder {
  font-size:20px;
}
.doc-nav-link {
  font-size:12px;
}
</style>
